import JudgeMePreviewBadge from 'components/judge-me-preview-badge';
import useIsClient from 'hooks/common/use-is-client';
import { StaticPDPProduct } from 'modules/product-details/types';

type Props = {
  product: StaticPDPProduct;
};

/**
 * Wrapper component for JudgeMePreviewBadge with click event attached
 */
const JudgeMeReviewBadgeWrapper: React.FC<Props> = ({ product }) => {
  const { isClient } = useIsClient();

  const handleJudgeMeClick = (): void => {
    const element = document.querySelector('.jdgm-widget');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isClient) return null;

  return (
    <div className="mb-1">
      <JudgeMePreviewBadge
        onClick={handleJudgeMeClick}
        productId={product.id}
        numberDisplayType={'number'}
      />
    </div>
  );
};

export default JudgeMeReviewBadgeWrapper;
